const messages = {
  errors: {
    invalidEmail: "Please enter correct email",
    invalidEmailFormat: "Invalid email format",
    emailRequired: "Please enter email",
    invalidFirstName: "First Name must be at least 3 characters long",
    firstNameRequired: "Please enter first name",
    invalidLastName: "Last Name must be at least 3 characters long",
    lastNameRequired: "Please enter last name",
    phoneRequired: "Please enter phone number",
    walletAddressRequired: "Please enter wallet address",
    phoneExists: "Phone number already exists",
    invalidPhone: "Please enter valid phone number",
    phoneValidationFailed: "Failed to validate phone number",
    invalidPassword: "Password must be at least 6 characters long",
    invalidConfirmPassword:
      "Confirm Password must be at least 6 characters long",
    reqPassword:
      "Your password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
    reqConfirmPassword:
      "Your confirm password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
    passwordRequired: "Please enter a password",
    confirmPasswordRequired: "Please enter a confirm password",
    passwordNotMatch: "Passwords do not match",
    confirmPassNotMatch: "confirm password doesn't matches with password",
    requireEmailVerify:
      "Your email is not verified yet. Verification email has been sent to registered email address. Please verify it to log in to your account. If you didn't received an email, please contact admin at info@lfcoin.io",
    serverError: "Internal server error! Please try again",
    somethingWentWrong: "Something went wrong! Please try again.",
    tokenExpire: "Token expired. Please request a new one.",
    tokenNotFound: "No token found in URL, please try again",
    walletMismatch:
      "Connected wallet does not match the verified wallet. Please try connecting the verified wallet.",
    insufficientBalance:
      "You don't have enough SOL to proceed with this transaction.",
    transactionTimeout:
      "Transaction is not completed in time. Please try again.",
    enterAmount: "Please enter an amount more than 0.",
    tokenLimitRequired: "Please enter token limit quantity.",
    fetchLimitFailed: "Failed to fetch token limit",
    limitSetFailed: "Failed setting token limit",
    fetchTokenHistoryFailed: "Failed to fetch $LAL token purchase history",
    fetchLatestDeployedTokenFailed: "Failed to fetch latest deployed token",
    fetchLatestDeployedAndMintedTokenFailed:
      "Failed to fetch current running token",
    fetchTokenCreationHistoryFailed: "Failed to fetch token history",
    fetchSolHistoryFailed: "Failed to fetch Solana Purchase history",
    fetchUsersFailed: "Failed to fetch users",
    resendLinkFailed: "Failed to resend activation link",
    solRequired: "Please enter amount more than 0",
    decodeImageFailed: "Failed to decode image, Please try again",
    invalidAddress: "Invalid address format.",
    errorAcceptance: "Please accept the terms and conditions",
    requestPending: "One wallet address already pending for update",
    requiredFieldsFilled: "Please ensure all required fields are filled.",
    walletAlreadyUsed:
      "Provided wallet address already updated in your profile",
    walletAlreadyUsedBySomeOne:
      "Provided wallet address already used in other user profile",
    alreadyPendingInProfile:
      "Provided wallet address already pending in your profile",
    provideWallet: "Please provide Wallet Address",
    tokenInitializeFailed: "Contract Initialization Failed. Please try again",
    errorTokenLimit: "Note: Token limit should not be negative",
    errorWalletConnection: "Please connect wallet",
    tokenQuantityRequired: "Please enter token quantity",
    errorTokenQuantity: "Please enter token quantity more than 0.",
  },
  success: {
    resetLinkSent:
      "Password reset link has been sent to your email. Please check email and reset your password.",
    resetSuccess:
      "Your password has been reset successfully! Please login to continue",
    successSignUp:
      "Thank you for registering. A verification email has been sent to your email. Please open the email and click the link to verify your email address",
    successEmailVerify:
      "Your email verification is successful! Please login to continue",
    successUnsetLimit:
      "You have successfully unset the daily token purchase limit. Maximum limit is applied.",
    successResendLink: "Resend Activation link successful",
    successUpdateProfile: "Your profile is successfully updated",
    successRequest: "Request submitted successfully.",
    successApproveRequest: "Request Approved Successfully.",
    successRejectRequest: "Request Rejected Successfully.",
    tokenInitializeSuccess: "Contract Initialization Successful.",
    successJoinCommunity:
      "You have successfully signed up to join our community",
  },
  titles: { success: "Success!", error: "Error!", warning: "Warning!" },
  buttons: { goToLogin: "Go to Login", close: "Close", ok: "OK" },
};

export default messages;
